"use client"

import { useState } from "react"
import { Layout, Menu, Card, Row, Col, Typography } from "antd"
import {
  FileTextOutlined,
  ShoppingCartOutlined,
  LogoutOutlined,
  ShoppingOutlined,
} from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import "../assets/styles/Profile.css"
import Cart from "../pages/Cart"
import { doSignOut } from "../firebase/auth"
import { useAuth } from "../contexts/authContext/index"
import SomeOfMyProducts from "../components/SomeOfMyProducts"
import MyQuoteRequests from "../pages/MyQuoteRequests"
import IncomingQuoteRequests from "../pages/IncomingQuoteRequests"

const { Content } = Layout
const { Title } = Typography

const Profile = () => {
  const navigate = useNavigate()
  const [selectedMenu, setSelectedMenu] = useState("1")
  const { currentUser } = useAuth()
  const userRole = (currentUser?.photoURL || "").toLowerCase()
  const isVendor = userRole === "vendedor" || userRole === "seller" || userRole === "proveedor"

  const handleLogout = () => {
    doSignOut()
    navigate("/")
    window.location.reload()
  }

  const renderContent = () => {
    switch (selectedMenu) {
      case "1":
        return (
          <div>
            {isVendor ? (
              <IncomingQuoteRequests embedded={true} />
            ) : (
              <MyQuoteRequests embedded={true} />
            )}
          </div>
        )
      case "2":
        return (
          <div>
            <Cart />
          </div>
        )
      case "3":
        return (
          <div>
            <SomeOfMyProducts />
          </div>
        )
      default:
        return null
    }
  }

  return (
    <Layout className="profile-layout">
      <Content className="profile-content">
        <Row gutter={24}>
          <Col xs={24} sm={24} md={8} lg={6} xl={5}>
            <Card className="navigation-card">
              <div className="navigation-header">
                <Title level={4}>{currentUser.displayName}</Title>
                <p>{currentUser.photoURL}</p>
              </div>
              <Menu
                mode="inline"
                selectedKeys={[selectedMenu]}
                onClick={({ key }) => setSelectedMenu(key)}
                items={[
                  {
                    key: "1",
                    icon: <FileTextOutlined />,
                    label: "Mis Cotizaciones",
                  },
                  ...(!isVendor
                    ? [
                        {
                          key: "2",
                          icon: <ShoppingCartOutlined />,
                          label: "Carrito de Compras",
                        },
                      ]
                    : [
                        {
                          key: "3",
                          icon: <ShoppingOutlined />,
                          label: "Tus productos",
                        },
                      ]),
                  {
                    key: "4",
                    icon: <LogoutOutlined />,
                    label: "Cerrar Sesión",
                    onClick: handleLogout,
                  },
                ]}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={16} lg={18} xl={19}>
            <Card className="content-card2">{renderContent()}</Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  )
}

export default Profile

